import React from 'react';
import { Link } from 'react-router-dom';

export const SETUP_ITEMS = [
  { label: 'Tenants', to: '/procore/setup/tenants', description: 'Company tenants and tenant users' },
  { label: 'Users', to: '/procore/setup/users', description: 'User accounts, roles, and access' },
  { label: 'Integrations', to: '/procore/setup/integrations', description: 'Procore, QuickBooks, and other connections' },
  { label: 'GL Settings', to: '/procore/setup/gl-settings', description: 'Default GL accounts and posting methods' },
  { label: 'WIP Settings', to: '/procore/setup/wip-settings', description: 'WIP report configuration' },
];

export const MASTER_DATA_ITEMS = [
  { label: 'Cost Codes', to: '/procore/master-data/cost-codes', description: 'Standard cost codes and divisions' },
  { label: 'Cost Types', to: '/procore/master-data/cost-types', description: 'Labor, material, subcontract, and other types' },
  { label: 'Labor Classes', to: '/procore/master-data/labor-classes', description: 'Labor classes used on project labor rate schedules' },
  { label: 'Vendors', to: '/procore/master-data/vendors', description: 'Vendor companies used on commitments and AP' },
  { label: 'Customers', to: '/procore/master-data/customers', description: 'Owner and customer records' },
  { label: 'Employees', to: '/procore/master-data/employees', description: 'Employee records for labor costs' },
  { label: 'Chart of Accounts', to: '/procore/master-data/chart-of-accounts', description: 'GL accounts for posting' },
  { label: 'Accounting Periods', to: '/procore/master-data/accounting-periods', description: 'Open and closed fiscal periods' },
];

function ItemList({ items }) {
  return (
    <div className="pc-report-list">
      {items.map((item) => (
        <Link key={item.to} className="pc-report-item" to={item.to}>
          <strong>{item.label}</strong>
          <span>{item.description}</span>
        </Link>
      ))}
    </div>
  );
}

export default function SettingsLandingPage() {
  return (
    <div className="pc-page">
      <div className="pc-crumb">Company / Settings</div>
      <div className="pc-title-row">
        <h1>Settings</h1>
      </div>
      <div className="pc-settings-grid">
        <section>
          <h2 className="pc-settings-heading">Setup</h2>
          <ItemList items={SETUP_ITEMS} />
        </section>
        <section>
          <h2 className="pc-settings-heading">Master Data</h2>
          <ItemList items={MASTER_DATA_ITEMS} />
        </section>
      </div>
    </div>
  );
}
